import { useDispatch } from 'react-redux';

import { useUploadVaxFileMutation } from 'api/glob.api.js';
import { vaxEditDataActions } from 'store/vaxEditDataSlice.js';

const useUploadVaxEditFile = () => {
  const dispatch = useDispatch();
  const [uploadVaxFile] = useUploadVaxFileMutation();
  const uploadFile = (formData, filename) => {
    dispatch(
      vaxEditDataActions.upload({
        filename,
        src: URL.createObjectURL(formData.get('vaxFile'))
      })
    );
    uploadVaxFile({
      body: formData,
      onProgress: e => {
        dispatch(
          vaxEditDataActions.uploadStatus({
            total: e.total,
            loaded: e.loaded,
            filename
          })
        );
      },
      filename
    })
      .unwrap()
      .then(result => {
        dispatch(vaxEditDataActions.uploadFinished(result));
      });
  };
  return uploadFile;
};

export default useUploadVaxEditFile;
